export const xp_data = [
  {
    job_title: "Frontend Developer | Project Manager",
    company: "Amplif Digital",
    company_link:"",
    year: "Jan 2023 - Mar 2023",
    job_desc: [
      "Directed frontend development for multiple client projects, delivering results on time and within budget.",
      "Spearheaded the redesign of key web applications, improving load times by 25%.",
      "Collaborated with teams to troubleshoot and resolve complex UI and performance issues, enhancing usability and customer satisfaction.",
    ],
  },
  {
    job_title: "Software Engineer (Frontend)",
    company: "Creatvise",
    company_link:"",
    year: "Apr 2023 - Jan 2024",
    job_desc: [
      "Engineered interactive browser-based features using TypeScript and object-oriented design patterns within an HTML Canvas environment.",
      "Configured and optimized Webpack build pipelines for modular architecture, efficient bundling, and improved development workflow.",
      "Designed reusable, maintainable class-based components to manage rendering logic, state, and user interactions.",
      "Implemented performance-conscious rendering techniques to ensure smooth canvas updates and responsiveness.",
      "Collaborated cross-functionally to translate product requirements into performant, production-ready frontend solutions.",
    ],
  },
  {
    job_title: "Contributor (Frontend Engineer)",
    company: "Kromatika Finance",
    company_link:"https://app.kromatika.finance/",
    year: "Mar 2024 - Present",
    job_desc: [
      "Built and enhanced decentralized application interfaces using TypeScript, React, Redux, and styled-components for a seamless DeFi trading experience.",
      "Integrated Uniswap SDK and web3-react to enable secure token swaps and multi-wallet connectivity across major Ethereum wallets.",
      "Improved trading app performance by implementing lazy loading and refactoring key modules, increasing Lighthouse scores by 15%.",
      "Maintained a scalable UI component library, ensuring responsiveness and long-term maintainability.",
      "Collaborated with blockchain engineering teams to align frontend logic with smart contract functionality.",
      "Used ethers.js with strict TypeScript typing to manage on-chain data and handle blockchain transaction states.",
      "Ensured high-quality code through peer reviews and best practices.",
    ],
  },
  {
    job_title: "Freelance Frontend Engineer",
    company: "SpaceBox Technology",
    company_link:"",
    year: "Jan 2024 - Present",
    job_desc: [
      "Building scalable cross-platform applications using Ionic, React, TypeScript, TailwindCSS, and shadcn/ui.",
      "Implementing monorepo architecture (Turborepo / Nx) to streamline development and improve maintainability across multiple apps.",
      "Improved trading app performance by implementing lazy loading and refactoring key modules, increasing Lighthouse scores by 15%.",
      "Collaborating with design and backend teams to ship performant mobile-first experiences aligned with product goals.",
      "Developing reusable UI components and enforcing consistent coding standards across teams.",
      "Improving navigation flows, app responsiveness, and UX across both web and mobile environments.",
    ],
  },
];
